import { StoryNode } from "../StoryBook/StoryData";
import { Box, Divider } from "@mui/material";
import React from "react";
import { UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants";
import { UILabel } from "./UILabel";
import { ColorUtilities } from "../../rule-engine-core/Common/ColorUtilities";

function ColorDisplay(props: { colorName: string; color: string }) {
    return (
        <Box
            width={"150px"}
            display={"flex"}
            flexDirection={"column"}
        >
            <Box
                height={"50px"}
                border={"1px solid " + UIStyleConstants.GRAY_DARK_COLOR}
                bgcolor={props.color}
            ></Box>
            <UILabel variant={"small"}>{props.colorName}</UILabel>
            <UILabel variant={"small"}>{props.color}</UILabel>
            <UILabel variant={"small"}>{ColorUtilities.rgb(props.color).toString()}</UILabel>
        </Box>
    );
}

export const ColorStories = [
    new StoryNode(
        () => {
            let keys = Object.keys(UIStyleConstants);
            let categories = Array.from(
                new Set(keys.filter((k) => k.indexOf("COLOR") !== -1).map((k) => k.split("_")[0])),
            );

            console.log(keys);
            console.log(categories);

            return (
                <Box
                    display={"flex"}
                    flexDirection={"row"}
                >
                    {categories.map((cat) => {
                        return (
                            <Box
                                display={"flex"}
                                flexDirection={"column"}
                                paddingRight={"5px"}
                                paddingBottom={"8px"}
                            >
                                <UILabel paddingBottom={"20px"}>{cat}</UILabel>
                                <Divider />
                                {keys
                                    .filter((k) => k.startsWith(cat))
                                    .map((k) => {
                                        return (
                                            <ColorDisplay
                                                colorName={k}
                                                color={Reflect.get(UIStyleConstants, k)}
                                            ></ColorDisplay>
                                        );
                                    })}
                            </Box>
                        );
                    })}
                </Box>
            );
        },

        "ColorStories",
    ),
];
